/*
    Get a list of direct child elements by class name.
*/
function childrenByClass(element, name) {
    var filtered = [];

    for (var i = 0; i < element.children.length; i++) {
        var child = element.children[i];
        var classNames = child.className.split(' ');
        if (classNames.indexOf(name) !== -1) {
            filtered.push(child);
        }
    }

    return filtered;
}

function toggleTabButton(event) {
    var i, index;
    var button = event.target;

    // Get index of the current button.
    var buttons = childrenByClass(button.parentNode, 'tab-button');
    for (i = 0; i < buttons.length; i++) {
        if (buttons[i] === button) {
            index = i;
            button.className = 'tab-button active';
        } else {
            buttons[i].className = 'tab-button';
        }
    }

    // Hide other tabs and show this one.
    var tabs = childrenByClass(button.parentNode.parentNode, 'tab');
    for (i = 0; i < tabs.length; i++) {
        if (i === index) {
            tabs[i].style.display = 'block';
        } else {
            tabs[i].style.display = 'none';
        }
    }
}

/**
 * Collapse or show a navigation menu.
 *
 * @param      {<type>}  event   The event
 * @return     {<type>}  { description_of_the_return_value }
 */
function toggleCollapseNav(event) {
    if (!event.target.classList.contains('heading')) return;
    if (typeof event.preventDefault !== 'undefined') event.preventDefault();
    const linkItems = document.getElementsByClassName('resource-group');
    Array.from(linkItems).forEach(element => element.classList.remove('active'));

    const currentLink = event.target.parentNode;
    return currentLink.classList.add('active');
}

const langBlocks = document.getElementsByClassName('block-language');

/**
 * Change the language the examples are displayed in
 *
 * @param      {<type>}  lang    The language
 * @return     {<type>}  { description_of_the_return_value }
 */
const changeLanguage = (lang) => {
    return Array.from(langBlocks).forEach((sib) => {
        if (sib.dataset.lang !== lang) {
            sib.style = 'display: none';
            return;
        }
        sib.style = 'display: block';
    })
}

/*
    Initialize the interactive functionality of the page.
*/
function init() {
    var i, j;

    var responseCodes = document.querySelectorAll('.example-names');
    for (i = 0; i < responseCodes.length; i++) {
        var tabButtons = childrenByClass(responseCodes[i], 'tab-button');
        for (j = 0; j < tabButtons.length; j++) {
            tabButtons[j].onclick = toggleTabButton;

            // Show by default?
            if (j === 0) {
                toggleTabButton({target: tabButtons[j]});
            }
        }
    }

    // Make nav items clickable to collapse/expand their content.
    var navItems = document.querySelectorAll('nav .resource-group');
    for (i = 0; i < navItems.length; i++) {
        navItems[i].onclick = toggleCollapseNav;
    }

    const radios = document.getElementsByName('language-toggle');

    for(var i = 0, max = radios.length; i < max; i++) {
        radios[i].onclick = (radio) => changeLanguage(radio.target.value)
    }

    if(window.location.hash) {
        const hash = window.location.hash;
        // Add active class to sidebar resource-group so that it opens up
        document.querySelector(`.sidebar a[href='${hash}']`).closest(".resource-group").classList.add('active');
    }

}

// Initial call to set up buttons
window.onload = () => init();
